import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

const ProfileNamePropsSchema = z.object({
  profileNameValue: z.string(),
})

type ProfileNameProps = z.infer<typeof ProfileNamePropsSchema>

export class ProfileName extends ValueObject<ProfileNameProps> {
  public getValue(): string {
    return this.props.profileNameValue
  }

  public static create(props: ProfileNameProps): ProfileName {
    const validatedProps = ProfileNamePropsSchema.parse(props)
    return new ProfileName(validatedProps)
  }
}
